<template>
  <j-modal
    :width="900"
    :visible="visible"
    :mask="true"
    :fullscreen="izMobile"
    class="j-super-query-modal"
    :zIndex="zIndex"
    style="top: 0; max-height: 95%"
    @cancel="handleCancel"
    @ok="handleOk"
    :footer="null"
  >
    <div slot="title">
      <span class="title">{{ currStudentInfo.name }}【{{ title }}】</span>
      <a-button type="primary" @click="exportToPdf">导出</a-button>
    </div>
    <div ref="exportContent">
      <a-card class="card-box" :bordered="false" :style="{ marginBottom: '24px' }">
        <div class="line-title title" style="margin-bottom: 5px">
          <div>{{ currStudentInfo.name }}{{ studentAnalysis.tendency.title }}</div>
          <div>
            <a-select
              v-model="timeType"
              placeholder="请选择时间"
              :options="timeTypeOptions"
              @select="selectTimeType"
            />
          </div>
        </div>
        <div class="salesCard">
          <LineChart
            height="220px"
            :fields="studentAnalysis.tendency.moodField"
            :dataSource="studentAnalysis.tendency.dataSource"
          />
        </div>
      </a-card>
      <a-card
        v-for="(item, index) in studentRecord"
        :key="index"
        class="card-box"
        :bordered="false"
        :style="{ marginBottom: '24px' }"
      >
        <TableList
          :titleStyle="{ fontSize: '15px', marginBottom: '10px' }"
          :title="`${currStudentInfo.name + item.title}`"
          :columns="item.columns"
          :tableData="item.tableData"
          :loading="loading"
          :pagination="item.pagination"
          @change="handleTableChange"
        />
      </a-card>
    </div>
  </j-modal>
</template>

<script>
import JDate from '@/components/jeecg/JDate.vue'
import { getAction } from '@api/manage'
import TableList from '@/components/chart/TableList'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import LineChart from '@/components/echartZyz/components/LineChart'
import { getDateRange } from '@/utils/util'

export default {
  name: 'TeacherCareModal',
  components: {
    JDate,
    TableList,
    LineChart,
  },
  props: {
    title: {
      type: String,
      default: '使用情况分析',
    },
  },
  data() {
    return {
      visible: false,
      labelCol: { span: 3 },
      wrapperCol: { span: 14 },
      form: {
        time: '',
        eventsType: '',
        eventsContent: '',
      },
      addEventId: '',
      currStudentInfo: {},
      timeType: -7,
      timeTypeOptions: [
        {
          label: '近七天',
          value: -7,
        },
        {
          label: '近20天',
          value: -20,
        },
        {
          label: '近40天',
          value: -40,
        },
        {
          label: '近三个月',
          value: -90,
        },
        {
          label: '近半年',
          value: -180,
        },
      ],
      //   今天 today 近七天 last7days 近20天 last20days 近40天 last40days 近三个月 last3months 近半年 last6months
      studentAnalysis: {
        // 心情趋势分析
        tendency: {
          title: '【使用情况分析】',
          dataSource: [],
          moodField: ['教师访问次数'],
        },
      },
      studentRecord: [
        {
          title: '【教师访问次数】',
          columns: [
            {
              title: '日期',
              dataIndex: 'type',
              align: 'center',
            },
            {
              title: '访问次数',
              dataIndex: '教师访问次数',
              align: 'center',
            },
          ],
          tableData: [],
          pagination: {
            current: 1,
            pageSize: 10,
            pageSizeOptions: ['10', '20', '50', '100'],
            showTotal: (total, range) => {
              return range[0] + '-' + range[1] + ' 共' + total + '条'
            },
            showSizeChanger: true,
            total: 0,
          },
        },
      ],
      loading: false,
    }
  },
  computed: {
    izMobile() {
      return this.device === 'mobile'
    },
  },
  methods: {
    resetModal() {
      this.studentAnalysis = {
        tendency: {
          title: '【使用情况分析】',
          dataSource: [],
          moodField: ['教师访问次数'],
        },
      }
    },
    show(data) {
      this.visible = true
      this.currStudentInfo = data
      this.loadData()
    },
    close() {
      this.$emit('close')
      this.visible = false
      this.resetModal()
      this.timeType = -7
    },
    handleCancel() {
      this.close()
    },
    handleOk() {},
    selectTimeType() {
      this.loadData()
    },
    exportToPdf() {
      const element = this.$refs.exportContent
      // 使用html2canvas将内容转换为PNG图片
      html2canvas(element, {
        useCORS: true, // 允许使用跨域图像
      }).then((canvas) => {
        const imgData = canvas.toDataURL('image/jpeg')

        // 创建一个新的jsPDF实例
        const pdf = new jsPDF()
        const imgWidth = 210 - 20 // A4页面宽度减去左右内边距（20mm）
        const pageHeight = pdf.internal.pageSize.height // 获取PDF页面高度

        const imgHeight = (canvas.height * imgWidth) / canvas.width // 根据比例计算图片高度
        let heightLeft = imgHeight // 剩余高度
        let position = 10 // 初始位置（顶部内边距10mm）

        // 分页处理
        while (heightLeft >= 0) {
          pdf.addImage(imgData, 'JPEG', 10, position, imgWidth, imgHeight) // 左右各10mm内边距
          heightLeft -= pageHeight // 减去页面高度
          position -= pageHeight // 移动位置至下一页
          if (heightLeft >= 0) {
            pdf.addPage() // 需要新页面时，添加新页面
          }
        }

        // 保存PDF文件
        pdf.save(`${this.currStudentInfo.name + this.title}.pdf`)
      })
    },
    async loadData() {
      this.loading = true
      const { beginDate, endDate } = getDateRange(this.timeType)
      const res = await getAction('/statistic/teacherVisit', {
        teacherId: this.currStudentInfo.id,
        beginDate,
        endDate,
        pageSize: this.studentRecord[0].pagination.pageSize,
        pageNo: this.studentRecord[0].pagination.current,
      })
      this.loading = false
      if (res.success) {
        // 变化趋势
        this.$set(this.studentAnalysis.tendency, 'dataSource', res.result.resultList)
        this.$set(this.studentRecord[0], 'tableData', res.result.pageResult.records)
        this.$set(this.studentRecord[0].pagination, 'total', res.result.pageResult.total)

        console.log('列表信息：', this.studentRecord[0])
      }
    },
    handleTableChange(pagination) {
      this.$set(this.studentRecord[0], 'pagination', pagination)
      this.loadData()
    },
  },
}
</script>

<style lang="less" scoped>
.title {
  font-size: 15px;
  font-weight: bold;
  margin-right: 12px;
}
.card-box {
  border: 1px solid #e4e4e4;
  border-radius: 10px;
  margin: 10px;
  ::v-deep {
    .ant-card-body {
      padding: 10px;
    }
  }
  .line-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    ::v-deep {
      .ant-select {
        width: 100px !important;
      }
    }
  }
}
</style>
